import React, { useState } from 'react'
import LeftControl from '../../Components/LeftControl'
import { Button, Checkbox, Col, Input, Row, Switch, Table } from 'antd'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import { EditOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useEffect } from 'react'
import { checkStatus, showText } from '../../helpers/textValidation'
import { useDispatch } from 'react-redux'
import LocomotiveModal from './ModalLocomotive'
import { createLocomotive } from '../../Services/LocomotiveServices'
import PageLayout from '../LayoutComponents/PageLayout'
import InspectionModalDue from './InspectionDue.modal'
const Listing = ({ ListingApi, name, path, exportListing, setFilter, resetFilter, state, showAddButton, showDeleteButton }) => {

    const filterVal = state
    const dispatch = useDispatch()
    const history = useHistory()
    const [dataForAntdTable, setdataForAntdTable] = useState([])
    const [modalVisible, setModalVisible] = useState()
    const [switchChecked, setSwitchChecked] = useState(false);
    const [insepctionModalOpen, setInsepctionModalOpen] = useState(false)

    const listingOffset = JSON.parse(localStorage.getItem('listing-offset'))
    const [PageDisplay, setPageDisplay] = useState({ rows: 10, total: 100, page: listingOffset?.page || 1 })

    const getUpdatedData = () => {
        let data = {
            EquipUID: filterVal?.equipUid ? filterVal?.equipUid : [],
            Loco_Model: filterVal?.model ? filterVal?.model : [],
            Unit_Type: filterVal?.uType ? filterVal?.uType : [],
            Loco_HP: filterVal?.hp ? filterVal?.hp : [],
            EquipStatus: filterVal?.status ? filterVal?.status : [],
            EquipLocation: filterVal?.location ? filterVal?.location : [],
        }
        return data
    }
    const handleOpenModal = () => {
        setModalVisible(true);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
    };


    const handleModalSubmit = async (values) => {
        try {
            const response = await createLocomotive(values,);

            if (response && response.httpStatus === 200) {
                handleCloseModal();
                await getData();
            } else {
                console.error('Form submission failed:', response);
            }
        } catch (error) {
            console.error('Error submitting the form:', error);
        }


    };
    const handleChange = (pagination, filters, pagesize) => {
        const newDeleteFilter = switchChecked ? state.deleteFilter : false;

        localStorage.setItem('listing-offset', JSON.stringify({ current: pagination?.current, page: (pagination?.pageSize * pagination?.current) - pagination?.pageSize + 1 }))
        if (switchChecked !== state?.deleteFilter) {
            setPageDisplay({ ...PageDisplay, page: (pagination?.pageSize * pagination?.current) - pagination?.pageSize + 1, rows: pagination?.pageSize * pagination?.current });
        }
        // setPageDisplay({ ...PageDisplay, page: (pagination?.pageSize * pagination?.current) - pagination?.pageSize + 1, rows: pagination?.pageSize * pagination?.current })
        // dispatch(setFilter(filters))
        dispatch(setFilter({ ...filters, deleteFilter: newDeleteFilter }));
    };

    const getData = async () => {
        const data = getUpdatedData();
        // Add the toggle button value to the data object
        data.Delete = [state?.deleteFilter];

        const result = await ListingApi(data);

        if (result?.httpStatus === 200) {
            setPageDisplay({ ...PageDisplay, total: result?.data?.length });

            setdataForAntdTable(
                result?.data?.map((item) => {
                    return {
                        equipUid: showText(item?.EquipUID),
                        model: showText(item?.Loco_Model),
                        hp: showText(item?.Loco_HP),
                        location: item?.TGSLocation || "N-A",
                        uType: item?.Unit_Type,
                        status: item?.status || "N-A",
                        allStatus: showText(item?.status),
                        poweredAxels: showText(item?.Axles),
                        id: item?.id,

                    };
                })
            );

        }
    };

    function removeDuplicateObjects(arr) {
        const uniqueObjects = [];
        const seenObjects = new Set();
        for (const obj of arr) {
            const objString = JSON.stringify(obj);
            if (!seenObjects.has(objString)) {
                seenObjects.add(objString);
                uniqueObjects.push(obj);
            }
        }

        return uniqueObjects;
    }
    // Export function
    const exportData = async () => {
        const data = getUpdatedData()
        if (showDeleteButton) {
            data.Delete = [switchChecked];
        }

        const result = await exportListing(data)
        const blob = new Blob([result], { type: 'text/csv' });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${name}.csv`;
        link.click();
        window.URL.revokeObjectURL(blobUrl);
    }

    const handleResetFilter = () => {
        dispatch(resetFilter());

        setSwitchChecked(false);

        dispatch(setFilter({ deleteFilter: false }));

    };

    const columns = [

        {
            title: 'Equip ID',
            dataIndex: 'equipUid',
            key: 'equipUid',
            filters: removeDuplicateObjects(dataForAntdTable?.map(x => ({ text: x?.equipUid, value: x?.equipUid }))),
            filteredValue: filterVal?.equipUid || null,
            filterSearch: true,
            onFilter: (value, record) => record?.equipUid?.includes(value),
            onFilterDropdownVisibleChange: (visible) => {
                if (visible) {
                    setTimeout(() => {
                        const searchInput = document.querySelector('.ant-input-affix-wrapper input');
                        if (searchInput) {
                            searchInput.focus();
                            searchInput.select();

                            const handleKeyPress = (event) => {
                                if (event.key === 'Enter') {
                                    const firstOption = document.querySelector('.ant-dropdown-menu-item:not(.ant-dropdown-menu-item-disabled)');
                                    if (firstOption) {
                                        firstOption.click();
                                    }
                                }
                            };

                            searchInput.addEventListener('keydown', handleKeyPress);
                        }
                    }, 0);
                }
            },
            ellipsis: true,
            width: '100px',
        },

        {
            title: 'Model',
            dataIndex: 'model',
            key: 'model',
            filters: removeDuplicateObjects(dataForAntdTable.map(x => { return { text: x?.model, value: x?.model } })),
            filteredValue: filterVal?.model || null,
            filterSearch: true,
            onFilter: (value, record) => record.model.includes(value),
            ellipsis: true,
            width: "90px"

        },
        {
            title: 'Horsepower',
            dataIndex: 'hp',
            key: 'hp',
            filters: removeDuplicateObjects(dataForAntdTable.map(x => { return { text: x?.hp, value: x?.hp } })).sort((a, b) => { return a.text - b.text }),
            filteredValue: filterVal?.hp || null,
            filterSearch: true,
            onFilter: (value, record) => record.hp === value,
            ellipsis: true,
            width: "120px"
        },
        {
            title: "Location",
            dataIndex: 'location',
            key: 'location',
            filters: removeDuplicateObjects(dataForAntdTable.map(x => { return { text: x?.location?.name ? x?.location?.name : "N-A", value: x?.location?.id ? x?.location?.id : null } })),
            filteredValue: filterVal?.location || null,
            filterSearch: true,
            // onFilter: (value, record) => record.uType.includes(value),
            ellipsis: false,
            width: "260px",
            render: (_, record) => {
                return <p>{record?.location?.name || "N-A"}</p>
            }
        },
        {
            title: 'Unit Type',
            dataIndex: 'uType',
            key: 'uType',
            filters: removeDuplicateObjects(dataForAntdTable.map(x => { return { text: x?.uType ? x?.uType : "N-A", value: x?.uType ? x?.uType : null } })),
            filteredValue: filterVal?.uType || null,
            filterSearch: true,
            // onFilter: (value, record) => record.uType.includes(value),
            ellipsis: true,
            width: "120px",
            render: (_, record) => {
                return <p>{record?.uType || "N-A"}</p>
            }

        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            filters: removeDuplicateObjects(dataForAntdTable.map(x => { return { text: x?.status ? checkStatus(x?.status) : 'N-A', value: x?.status?.id ? x?.status?.id : null } })),
            filteredValue: filterVal?.status || null,
            filterSearch: true,
            ellipsis: false,
            width: "200px",
            render: (data, item) => {
                return <p style={{ padding: "0px", margin: '0px' }}>{checkStatus(item?.status) ? checkStatus(item?.status) : "N-A"}</p>
            },
        },
        {
            title: 'Actions',
            dataIndex: 'id',
            key: 'id',
            render: (data, item) => {
                return <Button
                    onClick={() => { history.push({ pathname: path, state: { type: "Edit", data: item } }) }}
                    style={{ background: "#2863ad", color: 'white', display: "flex", gap: "10px", alignItems: "center" }}>
                    View <EditOutlined /></Button>
            },
            ellipsis: true,
            width: "100px"
        },
    ];

    useEffect(() => {
        dispatch(resetFilter());
        setSwitchChecked(state?.deleteFilter || false);
        dispatch(setFilter({ deleteFilter: false }));
        getData();

    }, []);

    useEffect(() => {
        getData()
    }, [filterVal])

    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">{name} Lookup</Grid>

                <div style={{ display: "flex", marginTop: "10px", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <div style={{ display: showAddButton ? 'unset' : 'none' }}>
                            <Button onClick={() => { exportData() }} style={{ background: "#2963ad", color: "white" }}>
                                Export {name}
                            </Button>
                        </div>
                        {showAddButton && (
                            <div>
                                <Button onClick={handleOpenModal} style={{ background: "#2963ad", color: "white" }}>
                                    Add {name}
                                </Button>
                            </div>
                        )}
                        <Button onClick={() => setInsepctionModalOpen(true)} style={{ background: "#2963ad", color: "white" }}>
                            Inspection Due
                        </Button>
                    </div>

                    <div style={{ marginLeft: '10px', marginTop: '10px' }}>
                        <Button
                            onClick={handleResetFilter}
                            style={{
                                backgroundColor: "#2963ad",
                                color: "white",
                                border: "none",
                                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                                marginBottom: "10px"
                            }}>
                            Reset Filters
                        </Button>
                    </div>
                </div>


                {showDeleteButton && (
                    <div style={{
                        alignItems: "center",
                        display: 'flex',
                        // justifyContent: 'space-between',
                        flexDirection: 'row-reverse'
                    }}>
                        <Switch
                            checked={switchChecked}
                            onChange={(checked) => {
                                setSwitchChecked(checked);
                                dispatch(setFilter({ ...state, deleteFilter: checked }));
                            }}
                            style={{
                                // backgroundColor: "#2963ad",
                                color: "white",
                                border: "none",
                                boxShadow: "#2963ad",
                                // marginLeft: '2px',
                            }}
                        />
                        <label style={{ marginRight: '10px', color: 'black' }}>Include Removed Equipment</label>
                    </div>
                )}


                <div className='LocomotiveListing' style={{ margin: "30px 0", position: 'relative' }}>
                    <Table
                        locale={{ filterReset: "" }}
                        pagination={
                            {
                                defaultPageSize: 10,
                                pageSizeOptions: ["10", "20", "25", "30", '50', '100'],
                                showSizeChanger: true, defaultCurrent: listingOffset?.current || 1
                            }
                        }
                        columns={columns}
                        dataSource={dataForAntdTable}
                        onChange={handleChange}
                        scroll={{ x: 400 }}
                        size="middle"
                        style={{ fontSize: "10px" }}
                    />
                    <p
                        style={
                            {
                                marginTop: '-32px',
                                position: 'absolute',
                                marginLeft: '5px',
                                backgroundColor: 'white',
                                padding: '5px',
                                color: "gray",
                                fontSize: '12px'

                            }}
                    >
                        {PageDisplay.page}-{PageDisplay.rows} of {PageDisplay.total}
                    </p>
                </div>

                <LocomotiveModal
                    visible={modalVisible}
                    onClose={handleCloseModal}
                    onSubmit={handleModalSubmit}
                />
                <InspectionModalDue
                    open={insepctionModalOpen}
                    close={() => setInsepctionModalOpen(false)}
                />
            </Grid>
        </PageLayout>
    )
}

export default Listing